export const mainLinks = [
    {
        title: 'O nas',
        url: '/i/o-nas'
    },
    {
        title: 'Aktualności',
        url: '/i/aktualnosci'
    },
    {
        title: 'Mapa strony',
        url: '/i/mapa-strony'
    },
    {
        title: 'Kontakt',
        url: '/i/kontakt'
    }
];

export const userLinks = [
    {
        title: 'Zasady pisania opinii',
        url: '/i/dla-uzytkownika/zasady-pisania-opinii'
    },
    {
        title: 'Wiarygodne Opinie',
        url: '/i/dla-uzytkownika/wiarygodne-opinie'
    },
    {
        title: 'Pytania (FAQ)',
        url: '/i/dla-uzytkownika/pytania-faq'
    },
    {
        title: 'Polityka prywatności',
        url: 'https://polityka-prywatnosci.onet.pl/index.html'
    },
    {
        title: 'Regulamin Opineo.pl',
        url: '/i/dla-uzytkownika/regulamin-dla-uzytkownikow-serwisu'
    },
    {
        title: 'Akt o Usługach Cyfrowych - informacja',
        url: '/i/dla-uzytkownika/akt-o-uslugach-cyfrowych-informacja'
    }
];

export const companyLinks = [
    {
        title: 'Jak zacząć współpracę',
        url: 'https://dolacz.opineo.pl/'
    },
    {
        title: 'Cennik',
        url: 'https://dolacz.opineo.pl/#cennik'
    },
    {
        title: 'Dołącz do Opineo.pl',
        url: 'https://dolacz.opineo.pl/'
    },
    {
        title: 'Pytania (FAQ)',
        url: '/i/dla-firm/pytania-faq'
    },
    {
        title: 'Regulamin',
        url: '/i/dla-firm/regulamindlapodmiotowwspolpracujacych'
    },
    {
        title: 'Odznaki i Certyfikaty Opineo',
        url: 'https://odznaki.opineo.pl/'
    }
];
